import React, { useState, useEffect } from 'react';
import AdvertisementList from './components/advertisement/AdvertisementList'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
export default function AdvertisementView() {
    const navigate = useNavigate();
    const userUID = useSelector(state => state.user.uid);
    const [garage, setGarage] = useState()
    const [showDiv, setShowDiv] = useState(false);
    useEffect(() => {
        if (userUID !== 'none') {
            axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAd', ownerID: userUID })
                .then(response => {
                    setGarage(response.data.data);
                    console.log("response", response.data.data)
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }

        const timer = setTimeout(() => {
            setShowDiv(true);
        }, 1200);
    }, [userUID]);


    const profile_complete = useSelector(state => state.user.profile_complete);
    useEffect(() => {
        if (profile_complete != true) {
            navigate('/edit_user');
            Swal.fire({
                icon: 'info',
                title: 'Please complete your profile first.',
            });
        }
    }, [profile_complete]);


    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className="page-content-details">
                    <div className="sec-title row">
                        <div className="col-md-6 text-start">
                            <h3>Advertisement</h3>
                        </div>
                        <div className="col-md-6 text-end">
                            <Link className='btn btn-primary btn-lg add_garage' to='/advertisement-add'>Add Advertisement</Link>
                        </div>
                    </div>
                    <div className='row'>
                        {garage ? <AdvertisementList garagesList={garage} actions={{ delete: true, edit: true, comingsoon: true }}></AdvertisementList> :
                            showDiv && <div className='typewriter '>No Advertisement yet</div>}
                    </div>
                </div>
            </div>
        </section>
    );
}